import React from 'react';
import { AttachFileOutlined } from '@material-ui/icons';

const ChatFooter = ({ status, sendFile }) => {
  let inputFileUpload = '';

  const handleSendFileClick = event => {
    event.preventDefault();
    inputFileUpload.click();
  }

  const handleSendFile = event => {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];

      if (file.size <= 10000000) {
        sendFile(file);
      }
    }
    event.target.value = null;
  }

  return (
    <div>
      {status !== 3 ? 
        <div>
          <button
            id="btn-send-file"
            className="btn-send-file"
            onClick={handleSendFileClick}
          >
            {<AttachFileOutlined />}
          </button>
          <input
            type="file"
            name="input-file-upload"
            ref={input => inputFileUpload = input} 
            style={{ display: 'none' }}
            onChange={handleSendFile.bind(this)}
            accept="image/png, image/jpeg, image/gif, image/webp, .pdf, .json, .doc, .docx, .txt"
          />
        </div>
        : <></>
      }
    </div>
  );
};

export default ChatFooter;